import React, { Component, Suspense, lazy } from "react";
import DarkTheme from "./themes/darkTheme";

class Header extends Component {

    render() {
        const theme = localStorage.getItem('theme');
        if (theme == 1) return <DarkTheme />;
        else
        {
            const LightTheme = lazy(() => import("./themes/lightTheme"));
            return (
                <Suspense fallback={<DarkTheme />}>
                    <LightTheme />
                </Suspense>
            );
        }
    }
}

export default Header;